import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
const F = "'Inter', system-ui, sans-serif";

export default function Nav() {
  const { isLoggedIn } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const linkStyle = ({ isActive }) => ({
    ...styles.link,
    ...(isActive ? styles.linkActive : {}),
  });

  return (
    <nav style={{ ...styles.nav, ...(scrolled ? styles.navScrolled : {}) }}>
      <div style={styles.inner}>
        <NavLink to="/" style={styles.brand}>
          <span style={styles.brandIcon}>🏕️</span>
          <span style={styles.brandText}>Lechcamping Spirkenhof</span>
        </NavLink>

        <button
          style={styles.burger}
          onClick={() => setMenuOpen(o => !o)}
          aria-label="Menü öffnen"
        >
          {menuOpen ? '✕' : '☰'}
        </button>

        <div style={{ ...styles.links, ...(menuOpen ? styles.linksOpen : {}) }}>
          <NavLink to="/" style={linkStyle} onClick={() => setMenuOpen(false)} end>Startseite</NavLink>
          <NavLink to="/galerie" style={linkStyle} onClick={() => setMenuOpen(false)}>Galerie</NavLink>
          <NavLink to="/cafe" style={linkStyle} onClick={() => setMenuOpen(false)}>Café</NavLink>
          <NavLink to="/referenzen" style={linkStyle} onClick={() => setMenuOpen(false)}>Bewertungen</NavLink>
          <NavLink to="/buchung" style={linkStyle} onClick={() => setMenuOpen(false)}>Buchung</NavLink>
          {isLoggedIn && (
            <NavLink to="/admin" style={linkStyle} onClick={() => setMenuOpen(false)}>Admin</NavLink>
          )}
          <NavLink
            to="/buchung"
            onClick={() => setMenuOpen(false)}
            style={{ ...styles.ctaLink }}
          >
            Jetzt anfragen
          </NavLink>
        </div>
      </div>
    </nav>
  );
}

const styles = {
  nav: {
    backgroundColor: 'white',
    borderBottom: '1px solid #e5e7eb',
    position: 'sticky',
    top: 0,
    zIndex: 200,
    transition: 'box-shadow 0.25s',
  },
  navScrolled: {
    boxShadow: '0 2px 16px rgba(0,0,0,0.08)',
  },
  inner: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 1.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '62px',
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    textDecoration: 'none',
  },
  brandIcon: { fontSize: '1.25rem' },
  brandText: {
    color: '#1e8449',
    fontWeight: '700',
    fontSize: '1.05rem',
    fontFamily: F,
    letterSpacing: '-0.2px',
  },
  links: {
    display: 'flex',
    gap: '0.15rem',
    alignItems: 'center',
  },
  linksOpen: {},
  link: {
    color: '#374151',
    textDecoration: 'none',
    padding: '0.42rem 0.8rem',
    borderRadius: '6px',
    fontFamily: F,
    fontSize: '0.9rem',
    fontWeight: '500',
    transition: 'background 0.15s, color 0.15s',
  },
  linkActive: {
    color: '#1e8449',
    backgroundColor: '#eafbef',
    fontWeight: '600',
  },
  ctaLink: {
    color: 'white',
    textDecoration: 'none',
    padding: '0.48rem 1.1rem',
    borderRadius: '8px',
    fontFamily: F,
    fontSize: '0.88rem',
    fontWeight: '600',
    backgroundColor: '#1e8449',
    marginLeft: '0.6rem',
  },
  burger: {
    display: 'none',
    background: 'none',
    border: 'none',
    color: '#374151',
    fontSize: '1.4rem',
    cursor: 'pointer',
    padding: '0.3rem',
  },
};
